import { Action } from "@ngrx/store";

export const GET_REPLACEMENT_VALUES_LIST = '[Replacement Values] Get Replacement Values List';
export const GET_REPLACEMENT_VALUES_LIST_SUCCESS = '[Replacement Values] Get Replacement Values List Success';
export const GET_REPLACEMENT_VALUES_LIST_FAIL = '[Replacement Values] Get Replacement Values List Fail';
export const UPDATE_REPLACEMENT_VALUES = '[Replacement Values] Update Replacement Values';
export const UPDATE_REPLACEMENT_VALUES_SUCCESS = '[Replacement Values] Update Replacement Values Success';
export const UPDATE_REPLACEMENT_VALUES_FAIL = '[Replacement Values] Update Replacement Values Fail';
export const ADD_REPLACEMENT_VALUES = '[Replacement Values] Add Replacement Values';
export const ADD_REPLACEMENT_VALUES_SUCCESS = '[Replacement Values] Add Replacement Values Success';
export const ADD_REPLACEMENT_VALUES_FAIL = '[Replacement Values] Add Replacement Values Fail';
export const DELETE_REPLACEMENT_VALUES = '[Replacement Values] Delete Replacement Values';
export const DELETE_REPLACEMENT_VALUES_SUCCESS = '[Replacement Values] Delete Replacement Values Success';
export const DELETE_REPLACEMENT_VALUES_FAIL = '[Replacement Values] Delete Replacement Values Fail';
export const RESET_REPLACEMENT_VALUES_CRUD = '[Replacement Values] Reset CRUD';
export const GET_TOTAL_INSURANCE_VALUES_LIST = '[Replacement Values] Get Total Insurance Values List';
export const GET_TOTAL_INSURANCE_VALUES_LIST_SUCCESS = '[Replacement Values] Get Total Insurance Values List Success';
export const GET_TOTAL_INSURANCE_VALUES_LIST_FAIL = '[Replacement Values] Get Total Insurance Values List Fail';
export const CLEAR_REPLACEMENT_VALUES_LIST = '[Replacement Values] Clear Replacement Values List';

export class GetReplacementValuesList implements Action {
  readonly type = GET_REPLACEMENT_VALUES_LIST;
  constructor(public payload: { institutionId: number } = null) { }
}

export class GetReplacementValuesSuccess implements Action {
  readonly type = GET_REPLACEMENT_VALUES_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetReplacementValuesListFail implements Action {
  readonly type = GET_REPLACEMENT_VALUES_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export class UpdateReplacementValues implements Action {
  readonly type = UPDATE_REPLACEMENT_VALUES;
  constructor(public payload: any = null) { }
}

export class UpdateReplacementValuesSuccess implements Action {
  readonly type = UPDATE_REPLACEMENT_VALUES_SUCCESS;
  constructor(public payload: any = null) { }
}

export class UpdateReplacementValuesFail implements Action {
  readonly type = UPDATE_REPLACEMENT_VALUES_FAIL;
  constructor(public payload: any = null) { }
}

export class AddReplacementValues implements Action {
  readonly type = ADD_REPLACEMENT_VALUES;
  constructor(public payload: any = null) { }
}

export class AddReplacementValuesSuccess implements Action {
  readonly type = ADD_REPLACEMENT_VALUES_SUCCESS;
  constructor(public payload: any = null) { }
}

export class AddReplacementValuesFail implements Action {
  readonly type = ADD_REPLACEMENT_VALUES_FAIL;
  constructor(public payload: any = null) { }
}

export class DeleteReplacementValues implements Action {
  readonly type = DELETE_REPLACEMENT_VALUES;
  constructor(public payload: any = null) { }
}

export class DeleteReplacementValuesSuccess implements Action {
  readonly type = DELETE_REPLACEMENT_VALUES_SUCCESS;
  constructor(public payload: any = null) { }
}

export class DeleteReplacementValuesFail implements Action {
  readonly type = DELETE_REPLACEMENT_VALUES_FAIL;
  constructor(public payload: any = null) { }
}

export class ResetReplacementValuesCRUD implements Action {
  readonly type = RESET_REPLACEMENT_VALUES_CRUD;
  constructor(public payload: any = null) { }
}

export class GetTotalInsuranceValuesList implements Action {
  readonly type = GET_TOTAL_INSURANCE_VALUES_LIST;
  constructor(public payload: { institutionId: number } = null) { }
}

export class GetTotalInsuranceValuesListSuccess implements Action {
  readonly type = GET_TOTAL_INSURANCE_VALUES_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetTotalInsuranceValuesListFail implements Action {
  readonly type = GET_TOTAL_INSURANCE_VALUES_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearReplacementValuesList implements Action {
  readonly type = CLEAR_REPLACEMENT_VALUES_LIST;
  constructor(public payload: any = null) { }
}

export type ReplacementValuesActions =
  | GetReplacementValuesList
  | GetReplacementValuesSuccess
  | GetReplacementValuesListFail
  | UpdateReplacementValues
  | UpdateReplacementValuesSuccess
  | UpdateReplacementValuesFail
  | AddReplacementValues
  | AddReplacementValuesSuccess
  | AddReplacementValuesFail
  | DeleteReplacementValues
  | DeleteReplacementValuesSuccess
  | DeleteReplacementValuesFail
  | ResetReplacementValuesCRUD
  | GetTotalInsuranceValuesList
  | GetTotalInsuranceValuesListSuccess
  | GetTotalInsuranceValuesListFail
  | ClearReplacementValuesList
  ;